import { createQueryClient } from '@piaas/piaas-ui-toolkit/hooks';

// One instance for the app's lifetime, shared with non-component code (e.g.
// a future route loader) that needs the same cache `useTableApiCall` uses.
const queryClient = createQueryClient();

export default queryClient;
